import { History } from 'lucide-react'
import { HistoryFilterMenu } from './filter-menu'
import { ViewSearchInput } from '../../../components/view-search-input'
import { View } from '../../../components/view'
import type { HistoryFilter } from '@renderer/overlay/Sidepanel/hooks/use-history-activity'

interface HistoryViewHeaderProps {
  searchQuery: string
  searchPlaceholder: string
  onSearchChange: (value: string) => void
  onFilterChange: (filter: HistoryFilter) => void
}

/**
 * Fixed view header per the History design: icon + title with the type filter
 * top right, and the full-width search pill underneath.
 */
export function HistoryViewHeader({
  searchQuery,
  searchPlaceholder,
  onSearchChange,
  onFilterChange,
}: HistoryViewHeaderProps) {
  return (
    <View.Header icon={<History />} title="History" accessory={<HistoryFilterMenu onFilterChange={onFilterChange} />}>
      <ViewSearchInput
        value={searchQuery}
        onChange={onSearchChange}
        placeholder={searchPlaceholder}
        label="Search history"
      />
    </View.Header>
  )
}
